import { useNavigate } from "react-router-dom";

/**
 * Thanh đầu trang dùng chung cho các màn hình làm việc trong kho.
 *
 * Luôn hiện tên kho đang làm việc: cầm máy đi giữa hai kho mà không thấy mình
 * đang ghi vào kho nào là cách nhanh nhất để tồn sai ở cả hai.
 */
export default function OpsHeader({
  title,
  subtitle,
  warehouseName,
  backTo = "/receiving",
  onBack,
}: {
  title: string;
  subtitle?: string;
  warehouseName?: string;
  backTo?: string;
  onBack?: () => void;
}) {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-20 bg-white border-b border-slate-200 px-3 py-2.5">
      <div className="flex items-center gap-2.5">
        <button
          onClick={() => (onBack ? onBack() : navigate(backTo))}
          className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-slate-100 text-slate-600 text-xl"
          aria-label="Quay lại"
        >
          &larr;
        </button>
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-slate-900 truncate">{title}</p>
          {subtitle && <p className="text-xs text-slate-500 truncate">{subtitle}</p>}
        </div>
        {warehouseName && (
          <span className="shrink-0 max-w-[42%] truncate text-[11px] font-medium px-2 py-1 rounded-full bg-brand-50 text-brand-700">
            {warehouseName}
          </span>
        )}
      </div>
    </header>
  );
}
